import cryptoJS from "crypto-js";
import { PAYLOAD_CRYPTO_SECRET_KEY } from "../utils/constant/globalEnv.constant";

const payloadCryptoKEY = PAYLOAD_CRYPTO_SECRET_KEY;

function encryptValue(value: string, SECRET_KEY: string) {
  return cryptoJS.AES.encrypt(value, SECRET_KEY).toString();
}

function decryptValue(encryptedValue: string, SECRET_KEY: string, changedToNum?: boolean) {
  if (!encryptedValue) return encryptedValue;
  const decrypted = cryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
  const value = decrypted.toString(cryptoJS.enc.Utf8);
  return changedToNum ? +value : value;
}

const encryptObject = (data: Record<string, any>, options: { keys?: string[]; SECRET_KEY: string; excludedKeys?: string[] }) => {
  const { keys, SECRET_KEY, excludedKeys } = options;
  const encryptedObj: any = {};

  for (const key in data) {
    const value = data[key];
    // Check for nested objects
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      encryptedObj[key] = encryptObject(value, options);
    } else {
      if (keys) {
        if (keys.includes(key)) {
          encryptedObj[key] = encryptValue(value.toString(), SECRET_KEY);
        } else {
          encryptedObj[key] = value;
        }
      } else {
        if (excludedKeys && excludedKeys.includes(key)) {
          encryptedObj[key] = value;
          continue;
        } else {
          encryptedObj[key] = encryptValue(value.toString(), SECRET_KEY);
        }
      }
    }
  }
  return encryptedObj;
};

const decryptObject = (data: Record<string, any>, options: { keys?: string[]; SECRET_KEY: string; covertNumKeys?: string[]; excludedKeys?: string[] }) => {
  const { keys, SECRET_KEY, covertNumKeys, excludedKeys } = options;
  const decryptedObj: any = {};

  for (const key in data) {
    const value = data[key];
    // Check for nested objects
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      decryptedObj[key] = decryptObject(value, options);
    } else {
      if (keys) {
        // only decrypt key which present in keys
        if (keys.includes(key)) {
          decryptedObj[key] = covertNumKeys ? decryptValue(value, SECRET_KEY, covertNumKeys.includes(key)) : decryptValue(value, SECRET_KEY);
          // Logger.info(`${key}-${value}-${decryptedObj[key]}`)
        } else {
          decryptedObj[key] = value;
        }
      } else if (excludedKeys) {
        if (excludedKeys.includes(key)) {
          decryptedObj[key] = value;
        } else {
          decryptedObj[key] = covertNumKeys ? decryptValue(value, SECRET_KEY, covertNumKeys.includes(key)) : decryptValue(value, SECRET_KEY);
        }
      } else {
        decryptedObj[key] = covertNumKeys ? decryptValue(value, SECRET_KEY, covertNumKeys.includes(key)) : decryptValue(value, SECRET_KEY);
      }
    }
  }

  return decryptedObj;
};

const payloadEncryption = (data: Record<string, any>, options?: { excludedKeys?: string[] }) => {
  return encryptObject(data, { SECRET_KEY: payloadCryptoKEY, ...options });
};

const payloadDecryption = (data: Record<string, any>, options?: { covertNumKeys?: string[]; excludedKeys?: string[] }) => {
  return decryptObject(data, {
    SECRET_KEY: payloadCryptoKEY,
    ...(options || {}),
  });
};
const payloadEncryptionValue = (value: string) => encryptValue(value, payloadCryptoKEY);
const payloadDecryptionValue = (value: string) => decryptValue(value, payloadCryptoKEY);

const Secure = {
  payloadEncryption,
  payloadDecryption,
  payloadEncryptionValue,
  payloadDecryptionValue,
};

export default Secure;
